<template>
    <v-sheet
      id="dropzone"
      ref="dzone"
      tabindex="0"
      :title="$t('label.dropFileOrClickToSelect')"
      width="100%"
      style="cursor:pointer;"
      height="200"
      color="#f0f0f0"
      :class="[{ 'dragover': dragover }, 'pa-2']"
    >
      <input
        ref="upload"
        id="fileUpload"
        type="file"
        :accept="accept"
        :multiple="multiple"
        style="display:none"/>
      <v-row justify="center">
        <v-icon
          v-if="!dragover"
          color="#00469C"
          size="75"
        >mdi-cloud-upload-outline</v-icon>
        <v-icon
          v-if="dragover"
          color="#00469C"
          size="75"
        >mdi-cloud-upload</v-icon>
      </v-row>
      <v-row justify="center">
        <span class="title primary--text text--darken-2">{{ $t('label.dropFileOrClickToSelect') }}</span>
      </v-row>
    </v-sheet>
</template>

<script>
import { showMessage } from '../../mixins'
export default {
  props: {
    accept: {
      type: String,
      required: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    extensions: {
      type: String,
      required: false,
      default: ''
    }
  },
  mixins: [showMessage],
  data: () => ({
    dragover: false
  }),
  methods: {
    filesSelected (files) {
      if (this.validateExtensions(files)) {
        this.$emit('filesSelected', this.multiple ? files : files[0])
      } else {
        this.showMessage(this.$t('message.error.invalidFileExtension'))
      }
      this.dragover = false

      // clean input
      if (this.$el.firstElementChild) {
        this.$el.firstElementChild.value = ''
      }
    },
    validateExtensions (files) {
      if (this.extensions.length > 0) {
        for (let i = 0; i < files.length; i++) {
          const ext = files[i].name.substr(files[i].name.lastIndexOf('.') + 1)
          if (this.extensions.toLowerCase().indexOf(ext.toLowerCase()) === -1) {
            return false
          }
        }
      }
      return true
    }
  },
  mounted () {
    const dropzone = this.$el
    const fileupload = this.$el.firstElementChild

    // register listeners on your dropzone / v-sheet
    if (dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener('dragenter', e => {
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener('dragleave', e => {
        e.preventDefault()
        this.dragover = false
      })
      dropzone.addEventListener('dragover', e => {
        e.preventDefault()
        this.dragover = true
      })
      dropzone.addEventListener('drop', e => {
        e.preventDefault()
        const dragevent = e
        if (dragevent.dataTransfer) {
          this.filesSelected(dragevent.dataTransfer.files)
        }
      })

      dropzone.addEventListener('click', e => {
        // e.preventDefault()
        if (fileupload) {
          fileupload.click()
        }
      })
      dropzone.addEventListener('keypress', e => {
        e.preventDefault()
        const keyEvent = e
        if (keyEvent.key === 'Enter') {
          if (fileupload) { fileupload.click() }
        }
      })
      // register listeners on the file input
      if (fileupload) {
        fileupload.addEventListener('change', e => {
          const target = e.target
          if (target.files) {
            this.filesSelected(target.files)
          }
        })
      }
    }
  }
}
</script>

<style>
  .dragover {
    border-style: dashed !important;
    border-color: #909090 !important;
    border-width: 3px !important;
  }
</style>
